
/**
 * @ngdoc directive
 * @name expand
 *
 * @description
 * Expand
 */
module.directive('expand', function () {
    'use strict';
    return {
        restrict: 'E',
        transclude: {
            title: '?expandTitle',
            body: '?expandBody'
        },
        scope: {
            isOpen: '=',
            isEnabled: '='
        },
        controller: ['$scope', function($scope) {
            $scope.changeBodyVisibility = function() {
                $scope.isOpen = !$scope.isOpen;
            };
        }],
        template:
        '<div class="aqua-expand--header"' +
        '     ng-click="isEnabled && changeBodyVisibility()"' +
        '     ng-class="{\'aqua-expand--header-disabled\': !isEnabled}">' +
        '   <span ng-class="{\'aqua-expand--header-icon--body-hidden\': !isOpen}" class="aqua-expand--header-icon"></span>' +
        '   <div ng-transclude="title"></div>' +
        '</div>' +
        '<div ng-transclude="body" ng-if="isOpen"></div>'
    };
});